// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"5b1ae77c","990":"25cb56b3"}[chunkId] + ".chunk.css";
};